<template lang="pug">
v-dialog(v-model="dialog" width="700" persistent)
    template(v-slot:activator="{ on, attrs }")
        v-btn.ml-2(small color="primary" dark v-bind="attrs" v-on="on")
            v-icon(small left) mdi-square-edit-outline
            | Update Template
    v-card
        v-card-title Update Notification Template
        v-card-text
            v-text-field(label="Template Name" v-model="form.name" :disable="loading")
            v-text-field(label="Template" v-model="form.message" :disable="loading" hint="Wild card will be {music}, {name} and {artistName}" persistent-hint)
            v-text-field(label="Type" v-model="form.target_type" :disable="loading" hint="Small characters only and only allow (a-z) and dash (-)." persistent-hint)
            v-checkbox(v-model="form.receive" label="Receive Push Notification" :disabled="loading")
        v-divider
        v-card-actions
            v-spacer
            v-btn(v-if="!loading" small color="red" text @click="dialog = false") Cancel
            v-btn(small color="primary" text @click="UpdateNotificationTemplate" :loading="loading") Submit
</template>


<script>
export default {
    props: {
        item: {
            type: Object,
            default() {
                return {};
            }
        }
    },
    data() {
        console.log('update');
        return {
            dialog: false,
            loading: false,
            form : {
                name: this.item.name,
                message: this.item.message,
                target_type: this.item.target_type,
                receive: this.item.receive,
            }
        };
    },
    methods: {
        async UpdateNotificationTemplate() {
            try {
                this.loading = true;
                this.item.name = this.form.name;
                this.item.message = this.form.message;
                this.item.target_type = this.form.target_type;
                this.item.receive = this.form.receive;
                await this.item.patch();
                this.$emit('success');
                this.dialog = false;
            } catch(err) {
                this.$emit('error', err);
            } finally {
                this.loading = false;
            }
        }
    }
}
</script>

<!-- <script lang="ts">
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component
export default class UpdateTemplateModal extends Vue {
    createnew: any;

    // Props
    @Prop({ default() { return {}; } })
    item!: any;

    // Data
    dialog = false;
    loading = false;
    form = {
        name: this.item.name,
        message: this.item.message,
        target_type: this.item.target_type
    };

    // Methods
    public async UpdateNotificationTemplate() {
        try {
            this.loading = true;
            this.item.name = this.form.name;
            this.item.message = this.form.message;
            this.item.target_type = this.form.target_type;
            await this.item.patch();
            this.$emit('success');
            this.dialog = false;
        } catch(err) {
            this.$emit('error', err);
        } finally {
            this.loading = false;
        }
    }

}
</script> -->
